// Alertes « commandes à traiter » (envoi à Y2 bloqué sur une commande en cours, api/erreursY2.js), en haut à droite :
// - à l'ouverture : les commandes passées à traiter depuis la dernière fois (session.aTraiterNouveaux),
//   jusqu'à ce que le popup soit fermé (user.preferences.saveATraiterVu) ;
// - en direct : une notification dès qu'une commande passe à traiter pendant que l'onglet est ouvert
//   (message « aTraiter » de /ws/direct, src/app/tools/direct.js).

import { createApp } from "vue";
import { Echangeur } from "../../Echangeur";
import { alertesATraiter } from "../../tools/direct";

const DUREE_NOTIFICATION = 30000; // ms avant qu'une notification en direct disparaisse seule

const html = `
<div class="alertes-a-traiter" aria-live="polite">
  <transition name="alerte">
    <div v-if="ouverture" class="alerte-a-traiter is-ouverture" role="status">
      <div class="alerte-a-traiter-tete">
        <span class="icon-tile tone-red"><i class="fa-solid fa-triangle-exclamation"></i></span>
        <div class="flex-grow-1 min-w-0">
          <div class="alerte-a-traiter-titre">
            {{ ouverture.count }} commande{{ ouverture.count > 1 ? 's' : '' }} à traiter
          </div>
          <div class="alerte-a-traiter-sub">Envoi à Y2 bloqué{{ dejaVu ? ' depuis votre dernière visite' : '' }}</div>
        </div>
        <button type="button" class="notes-version-close" title="Fermer" aria-label="Fermer" @click="fermerOuverture">
          <i class="fa-regular fa-xmark"></i>
        </button>
      </div>
      <ul class="alerte-a-traiter-liste">
        <li v-for="c in ouverture.rows.slice(0, 5)" :key="c._id">
          <a href="#" @click.prevent="ouvre(c._id)">{{ c.po }}</a>
          <span class="cell-sub"> · {{ c.nom }}</span>
          <div class="alerte-a-traiter-message" :title="c.message">{{ c.message }}</div>
        </li>
      </ul>
      <div class="alerte-a-traiter-pied">
        <button type="button" class="btn btn-white btn-sm" @click="fermerOuverture">Plus tard</button>
        <button type="button" class="btn btn-danger btn-sm" @click="voirTout">Voir les commandes à traiter</button>
      </div>
    </div>
  </transition>
  <transition-group name="alerte">
    <div v-for="a in direct.liste" :key="a.cle" class="alerte-a-traiter" role="alert">
      <div class="alerte-a-traiter-tete">
        <span class="icon-tile tone-red"><i class="fa-solid fa-bell"></i></span>
        <div class="flex-grow-1 min-w-0">
          <div class="alerte-a-traiter-titre">Nouvelle commande à traiter</div>
          <div class="alerte-a-traiter-sub">
            <a href="#" @click.prevent="ouvre(a._id, a.cle)">{{ a.po }}</a> · {{ a.nom }}
          </div>
          <div class="alerte-a-traiter-message" :title="a.message">{{ a.message }}</div>
        </div>
        <button type="button" class="notes-version-close" title="Fermer" aria-label="Fermer" @click="retire(a.cle)">
          <i class="fa-regular fa-xmark"></i>
        </button>
      </div>
    </div>
  </transition-group>
</div>
`;

let app = null;

function demarre(session) {
  // Nouvelle session (ex. après une déconnexion) : on repart propre
  if (app) {
    app.unmount();
    app = null;
  }
  document.querySelector("#alertesATraiter")?.remove();
  alertesATraiter.liste = [];
  if (!session) return;

  const el = document.createElement("div");
  el.id = "alertesATraiter";
  document.body.appendChild(el);

  const nouveaux = session.aTraiterNouveaux || { count: 0, rows: [] };
  app = createApp({
    template: html,
    data() {
      return {
        ouverture: null,
        dejaVu: !!nouveaux.depuis,
        direct: alertesATraiter,
      };
    },
    watch: {
      // Chaque notification en direct disparaît seule au bout d'un moment
      "direct.liste": {
        handler(liste) {
          for (const a of liste) {
            if (a.minuterie) continue;
            a.minuterie = setTimeout(() => this.retire(a.cle), DUREE_NOTIFICATION);
          }
        },
        deep: true,
      },
    },
    mounted() {
      // Après le popup des nouveautés, pour ne pas tout faire apparaître d'un coup
      if (nouveaux.count) setTimeout(() => (this.ouverture = nouveaux), 900);
    },
    methods: {
      ouvre(_id, cle) {
        window.location.hash = `#ordersSearch/ordersSearchDetail&_id=${_id}`;
        if (cle) this.retire(cle);
      },
      voirTout() {
        window.location.hash = "#ordersSearch&errors=traiter&filtres=lien";
        this.fermerOuverture();
      },
      retire(cle) {
        const i = this.direct.liste.findIndex((a) => a.cle === cle);
        if (i < 0) return;
        clearTimeout(this.direct.liste[i].minuterie);
        this.direct.liste.splice(i, 1);
      },
      async fermerOuverture() {
        this.ouverture = null;
        try {
          await Echangeur.rest("user.preferences.saveATraiterVu", {});
        } catch (e) {
          // Non enregistré : le popup réapparaîtra au prochain chargement
        }
      },
    },
  });
  app.mount(el);
}

export default { demarre };
